<ng-container *ngIf="isLoggedIn">
  <div class="submit-model-page">
    <div class="submit-model-page__content">
      <div class="submit-model-page__main">
        <div class="submit-model-page__inner">
          <app-reference-datasets
            [embedOnboardOnly]="true"
            [autoOpenDatasetKey]="datasetKey"
            [autoOpenDatasetLabel]="datasetLabel"
          ></app-reference-datasets>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</ng-container>

<app-login-modal
  *ngIf="showLoginModal"
  [redirectUri]="loginRedirectUri"
  (visibleChange)="onLoginModalClose($event)"
></app-login-modal>
